<ui-loading [loading]="action === 'loading'">
  <section class="ds-p">
    <!-- image -->

    <figure
      class="
        ds-relative
        md:ds-h-[19rem] md:ds-w-[19rem]
        ds-h-[16rem] ds-w-[16rem] ds-mx-auto ds-my-lg
      "
    >
      <div
        class="
          ds-rounded-full
          ds-overflow-hidden
          ds-h-full
          ds-w-full
          ds-bg-tertiary-lightgrey
        "
      >
        <ng-content
          select="[campaignProductCardFinlandProductImage]"
        ></ng-content>
      </div>
      <figcaption
        data-e2e-sticker
        class="
          ds-absolute
          ds-top-0
          ds-right-0
          ds-rounded-full
          ds-h-4xl
          ds-w-4xl
          ds-font-bold
          ds-leading-xs
          ds-flex
          ds-justify-center
          ds-items-center
          ds-text-center
          ds-text-primary-white
        "
        [class.ds-bg-secondary-darkgreen]="stickerColor === 'darkgreen'"
        [class.ds-bg-secondary-darkblue]="stickerColor === 'darkblue'"
        [class.ds-bg-secondary-pink]="stickerColor === 'pink'"
        [class.ds-bg-secondary-darkpurple]="stickerColor === 'darkpurple'"
        [class.ds-bg-secondary-green]="stickerColor === 'green'"
        [class.ds-bg-secondary-red]="stickerColor === 'red'"
        [class.ds-bg-secondary-purple]="stickerColor === 'purple'"
      >
        <ng-content
          select="[campaignProductCardFinlandStickerLabel]"
        ></ng-content>
      </figcaption>
    </figure>

    <!-- agreement name -->

    <header class="ds-text-4xl ds-font-bold ds-py">
      <span #loader>{{ agreementName }}</span>
    </header>

    <!-- description -->

    <ui-truncate>
      <ng-content
        select="[campaignProductCardFinlandProductDescription]"
      ></ng-content>
      <span expand>
        <ng-content
          select="[campaignProductCardFinlandShowMoreLabel]"
        ></ng-content>
      </span>
      <span collapse>
        <ng-content
          select="[campaignProductCardFinlandShowLessLabel]"
        ></ng-content>
      </span>
    </ui-truncate>

    <!-- co2 -->

    <div class="sm:ds-min-h-[14.5rem] ds-relative">
      <aside class="ds-py-xs ds-font-bold">
        <div
          class="
            ds-h-sm
            ds-w-sm
            ds-mr-sm
            ds-rounded-full
            ds-inline-block
            ds-bg-primary-blue
          "
        ></div>
        <ng-content select="[campaignProductCardFinlandCO2Label]"></ng-content>
        <ng-container *ngIf="estimatedCo2EmissionPerMonthUnit?.value">
          {{ estimatedCo2EmissionPerMonthUnit | unit: "1.1-1" }}
        </ng-container>
        <ui-tooltip class="ds-mx-2xs">
          <ui-tooltip-label>
            <ng-content
              select="[campaignProductCardFinlandCO2Description]"
            ></ng-content>
          </ui-tooltip-label>
          <span
            class="
              ds-icon ds-icon-info ds-cursor-pointer ds-relative
              -ds-bottom-2xs
            "
            tabindex="0"
          ></span>
        </ui-tooltip>
      </aside>

      <!-- prices -->

      <ui-error [error]="action === 'errorred'">
        <div #errorMessage>
          <ng-content
            select="[campaignProductCardFinlandErrorMessage]"
          ></ng-content>
        </div>
        <div class="ds-border-t ds-border-b ds-border-[#979797] ds-py-xs">
          <!-- monthly base fee -->
          <section>
            <span class="ds-pr-xs">
              <ng-content
                select="[campaignProductCardFinlandMonthlyBaseFeeLabel]"
              ></ng-content>
            </span>
            <span
              #loader
              class="ds-font-bold"
              [class.ds-line-through]="isDiscountedProduct"
            >
              {{ monthlyBaseFee | unit: "1.2-2" }}
            </span>
            <span
              class="ds-text-secondary-pink ds-pl-xs ds-font-bold"
              *ngIf="isDiscountedProduct"
            >
              {{ discountedMonthlyBaseFee | unit: "1.2-2" }}
            </span>
          </section>

          <!-- discount length -->
          <section *ngIf="discountLength?.value">
            <span class="ds-pr-xs">
              <ng-content
                select="[campaignProductCardFinlandDiscountLengthLabel]"
              ></ng-content>
            </span>
            <span class="ds-font-bold">{{ discountLength | unit }}</span>
          </section>

          <!-- electricity spot price -->
          <section>
            <span class="ds-pr-xs">
              <ng-content
                select="[campaignProductCardFinlandElectricityPriceLabel]"
              ></ng-content>
            </span>
            <span #loader class="ds-font-bold">
              <ng-container *ngIf="productType === 'spot'">
                <ng-content
                  select="[campaignProductCardFinlandElectricityPricePrefix]"
                ></ng-content>
              </ng-container>
              {{ electricityPrice | unit: "1.2-2" }}
            </span>
          </section>

          <!-- origin fee -->
          <section *ngIf="originFee?.value">
            <span class="ds-pr-xs"> {{ energySourceName }}: </span>
            <span #loader class="ds-font-bold">
              {{ originFee | unit: "1.2-2" }}
            </span>
            <ui-tooltip class="ds-mx-2xs">
              <ui-tooltip-label>
                <ng-content
                  select="[campaignProductCardFinlandOriginFeeInformation]"
                ></ng-content>
              </ui-tooltip-label>
              <span
                class="
                  ds-icon ds-icon-info ds-cursor-pointer ds-relative
                  before:!ds-text-xl before:!ds-leading-sm
                "
                tabindex="0"
              ></span>
            </ui-tooltip>
          </section>

           <!-- spot guard fee -->
          <section *ngIf="spotGuardFee?.value">
            <span class="ds-pr-xs"> 
              <ng-content
                  select="[campaignProductCardFinlandSpotGuardFeeLabel]"
              ></ng-content></span>
            <span #loader class="ds-font-bold">
              {{ spotGuardFee | unit: "1.2-2" }}
            </span>
            <ui-tooltip class="ds-mx-2xs">
              <ui-tooltip-label>
                <ng-content
                  select="[campaignProductCardFinlandSpotGuardFeeInformation]"
                ></ng-content>
              </ui-tooltip-label>
              <span
                class="
                  ds-icon ds-icon-info ds-cursor-pointer ds-relative
                  before:!ds-text-xl before:!ds-leading-sm
                "
                tabindex="0"
              ></span>
            </ui-tooltip>
          </section>

          <!-- contract length -->
          <section>
            <span class="ds-pr-xs">
              <ng-content
                select="[campaignProductCardFinlandContractLengthLabel]"
              ></ng-content>
            </span>
            <span #loader class="ds-font-bold">
              <ng-container *ngIf="productType === 'fixed'">
                <ng-content
                  select="[campaignProductCardFinlandProductTypeFixedLabel]"
                ></ng-content>
                {{ contractLength | unit }}
              </ng-container>
              <ng-container
                *ngIf="productType === 'variable' || productType === 'spot'"
              >
                <ng-content
                  select="[campaignProductCardFinlandProductTypeVariableLabel]"
                ></ng-content>
              </ng-container>
            </span>
          </section>

          <!-- payment type -->
          <section
            *ngIf="
              campaignProductCardFinlandPaymentTypeLabel &&
              campaignProductCardFinlandPaymentTypeText
            "
          >
            <span class="ds-pr-xs">
              {{ campaignProductCardFinlandPaymentTypeLabel }}
            </span>
            <span #loader class="ds-font-bold">
              {{ campaignProductCardFinlandPaymentTypeText }}
            </span>
          </section>
        </div>

        <!-- electricity price -->
        <div
          class="
            ds-font-bold ds-text-4xl ds-h-3xl ds-leading-[3.6rem]
            lg:ds-absolute lg:ds-bottom-0
          "
        >
          <span #loader class="ds-font-bold">
            {{
              hideMonthlyCost === true
                ? ""
                : (estimatedElectricityPricePerMonthUnit | unit: "1.2-2") + "*"
            }}
          </span>
        </div>
      </ui-error>
    </div>

    <!-- button -->

    <button
      data-e2e-submit
      (click)="onSelected()"
      (keypress.enter)="onSelected()"
      class="ds-button ds-w-full ds-m-0"
      [disabled]="action === 'errorred'"
    >
      <ng-content
        select="[campaignProductCardFinlandRedirectButtonLabel]"
      ></ng-content>
    </button>

    <!-- fine print -->

    <div class="ds-text-xs ds-pt-2xs">
      <ng-content select="[campaignProductCardFinlandFinePrint]"></ng-content>
    </div>
  </section>
</ui-loading>
